import {
  TestAnswerFeedbackDisplayOption,
  TestAnswerFeedbackType,
} from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import TestElementChangeStateActions from 'components/Editor/cource/layout/controls/ElementControls/TestElementChangeState'
import Separator from 'components/Editor/cource/layout/controls/Separator'
import { AppMode } from 'services/Store/Project/enums'

import type { TestHotspotEditorActionsType, TestHotspotStateType } from './testHotspotTypes'

const TestSingleChoiceEditorActions: TestHotspotEditorActionsType = ({
  element: { value },
  customMode,
  mode,
  setState,
  state,
  setAppMode,
}) => {
  const isPro = mode.editorMode === AppMode.pro
  const showSeparator =
    value.displayFeedback === true &&
    value.displayOption !== TestAnswerFeedbackDisplayOption.perOption &&
    value.generalTypeFb === TestAnswerFeedbackType.validation

  return (
    <>
      {isPro && <EditableProMode customMode={customMode} mode={mode} setAppMode={setAppMode} />}
      {showSeparator && isPro && <Separator />}
      <TestElementChangeStateActions<TestHotspotStateType>
        setState={setState}
        state={state}
        value={value}
      />
    </>
  )
}

export default TestSingleChoiceEditorActions
